import React from 'react';
import { HomeIcon, UsersIcon, LocationIcon, CheckIcon } from '../Icons/Icons';
import './TrustSignals.css';

function TrustSignals() {
  const stats = [
    {
      icon: <HomeIcon size={32} color="#ffffff" />,
      value: '150,000+',
      label: 'Properties Listed',
      subtext: 'Verified listings'
    },
    {
      icon: <UsersIcon size={32} color="#ffffff" />,
      value: '50,000+',
      label: 'Happy Customers',
      subtext: 'Trust us'
    },
    {
      icon: <LocationIcon size={32} color="#ffffff" />,
      value: '50+',
      label: 'Cities Covered',
      subtext: 'Nationwide'
    },
    {
      icon: <CheckIcon size={32} color="#ffffff" />,
      value: '15+',
      label: 'Years Experience',
      subtext: 'Industry leader'
    }
  ];

  return (
    <section className="trust-signals">
      <div className="trust-signals-container">
        <div className="trust-signals-header">
          <h2>Why Choose PakMilkiyat?</h2>
          <p>Pakistan's most trusted real estate platform</p>
        </div>
        <div className="trust-signals-grid">
          {stats.map((stat, index) => (
            <div key={index} className="trust-signal-card">
              <div className="trust-signal-icon">{stat.icon}</div>
              <div className="trust-signal-content">
                <div className="trust-signal-value">{stat.value}</div>
                <div className="trust-signal-label">{stat.label}</div>
                <div className="trust-signal-subtext">{stat.subtext}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TrustSignals;
